<template>
<!-- 
xs(Extra Small)・・・主にスマホ対応
sm(Small)・・・主にタブレット
md(Medium) ・・・主にノートパソコンや横表示のタブレット
lg(Large)・・・主にデスクトップ
xl(Extra large)・・・4Kや大きなモニター 


v-if="$vuetify.breakpoint.xs"
-->
    <v-container fluid>
        <v-row>
            <v-col>
                <ScheduleList />          
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import ScheduleList from '@/components/title/ScheduleList';
    export default {
        components: {
            ScheduleList
        }
    }
</script>
